import { Pinia, createPinia } from 'pinia'
import { ApiServicePlugin } from '../plugins/api-service.plugin'
import { ApiConfiguration } from 'webshop-modules';

export function createSearchStore(apiConfiguration: ApiConfiguration): Pinia {
    const store = createPinia();
    store.use(ApiServicePlugin(apiConfiguration));
    
    return store;
}
